import { Button } from '@material-ui/core';
import en from '../../../lang/en-us';
const { dashboard } = en;

function FailureScreenList({ text = '' }) {
    return (
        <>
            <li>{text}</li>
        </>
    );
}
export default function FailureScreen({
    heading = '',
    subheading = dashboard.UpdateNominee.Failure.subHeading,
    backLink = '',
    info1 = '',
    infospan1 = '',
    info2 = '',
    infospan2 = '',
    info3 = '',
    list = [] as any,
    component: Component = FailureScreenList,
}) {
    return (
        <>
            <h2 className="heading">
                <a href={`/portal/${backLink}`}>
                    <img src="/images/left-arrow-black.svg" alt="" />
                </a>
                {heading}
            </h2>
            <div className="curved-bg-content nct-success-screen nct-failed-screen">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/failure-character.png"
                            alt=""
                        />
                        <h3 className="subheading">{dashboard.Failed.subHeading}</h3>
                        <p>{dashboard.Failed.subHeadingInfo1}</p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        {/* <ol>
                            {list.map((_childProps: any, index: any) => (
                                <Component {..._childProps} />
                            ))}
                        </ol> */}
                        <Button className="customBtn">{dashboard.Failed.buttonText}</Button>
                    </div>
                </div>
            </div>
        </>
    );
}
